import { render, staticRenderFns } from "./ProjectTemplateSelectDialog.vue?vue&type=template&id=292e9fab"
import script from "./ProjectTemplateSelectDialog.vue?vue&type=script&lang=js"
export * from "./ProjectTemplateSelectDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports